import { Requests } from "../common/request.common";
import { UserLocationResponseTypes } from "../common/response.common";
import { post, postEmpty } from "./common";

export const userLocation = {
    obtainLocations() {
        return postEmpty<UserLocationResponseTypes.ObtainLocations>(
            "/user-location/obtain-locations",
        );
    },
    locations(data: typeof Requests.UserLocation.Locations.Input) {
        return post<typeof data, UserLocationResponseTypes.Locations>("/user-locations", data);
    },
    check() {
        return postEmpty<UserLocationResponseTypes.Check>("/user-location/check");
    },
    record(data: typeof Requests.UserLocation.Record.Input) {
        return post<typeof data, UserLocationResponseTypes.Record>("/user-location/record", data);
    },
};
